import { FC } from 'react';
import styles from './LitresReader.module.scss';

interface ILitresReader {
  externalId: number;
}

const LitresReader: FC<ILitresReader> = ({ externalId }) => {
  return (
    <div id="place_where_text_set" className={styles.bookReader}>
      <iframe
        className="book-reader-iframe"
        src={`//www.litres.ru/pages/quickread/?art=${externalId}&amp;lfrom=345193223&amp;skin=normal&amp;widget=1.00&amp;iframe=1&amp;l=345193223`}
        scrolling="no"
        frameBorder="0"
        width="100%"
        height="650px"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
};

export default LitresReader;
